import { render, staticRenderFns } from "./OrderActionBillProvider.vue?vue&type=template&id=14fe08e2&"
import script from "./OrderActionBillProvider.vue?vue&type=script&lang=ts&"
export * from "./OrderActionBillProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports